import * as types from "./mutation_types";
import { Feed } from "../../../../interfaces/feed";

export default {
  [types.FEED_DELETE_SET_DELETED](state: any, deleted:Feed) {
    Object.assign(state, { deleted });
  },

  [types.FEED_DELETE_SET_ERROR](state: any, error: any) {
    Object.assign(state, { error });
  },

  [types.FEED_DELETE_TOGGLE_LOADING](state: any) {
    Object.assign(state, { error: "", isLoading: !state.isLoading });
  },

  [types.FEED_DELETE_RESET](state: any) {
    Object.assign(state, {
      deleted: null,
      error: "",
      isLoading: false,
    });
  },
};
